import { ENDONYMS, LANGS, isLangId, type LangId } from "@aybuben/core/lang.ts";
import { Globe } from "lucide-react";

import { useStrings } from "../i18n/index.tsx";
import { COL } from "../theme.ts";

interface LangPillProps {
	lang: LangId;
	onLang: (l: LangId) => void;
}

/** A native select: the phone's own picker, and it scales past two languages. */
export function LangPill({ lang, onLang }: LangPillProps) {
	const t = useStrings();
	return (
		<label
			className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-semibold focus-within:outline focus-within:outline-4 focus-within:outline-offset-2 focus-within:outline-blue-400"
			style={{ background: COL.card, border: `1.5px solid ${COL.line}`, color: COL.ink }}
		>
			<Globe size={16} aria-hidden />
			<select
				aria-label={t("common.language")}
				value={lang}
				onChange={(e) => {
					const v = e.target.value;
					if (isLangId(v)) onLang(v);
				}}
				className="cursor-pointer appearance-none bg-transparent font-semibold focus:outline-none"
			>
				{LANGS.map((l) => (
					<option key={l} value={l} lang={l}>
						{ENDONYMS[l]}
					</option>
				))}
			</select>
		</label>
	);
}
